import { getListName } from 'analytics/enhanced-ecommerce'
import OfferCardCarouselSection from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import { OfferListEventsProvider } from 'components/OfferList/OfferListEventsContext'
import Places from 'constants/places'
import useOfferListTracking from 'hooks/Offers/useOfferListTracking'
import { useAppSelector } from 'hooks/reduxHooks'
import { getSearchQueryFromFilter } from 'lib/search/searchUtils'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import { FormattedMessage } from 'react-intl'
import { LUX_PLUS_MONTH_CAMPAIGN_ID } from 'takeovers/luxPlusMonthTakeover/constants/luxPlusMonthTakeoverConstants'

const FILTERS: App.OfferListFilters = {
  offerTypes: ['hotel', 'tactical_ao_hotel', 'tour_v2'],
  luxPlusFeatures: ['Early access'],
  campaigns: [LUX_PLUS_MONTH_CAMPAIGN_ID],
  destinations: [Places.Anywhere.id],
  sortBy: 'vertical-luxplus',
  limit: 20,
}

const ALL_LINK = `/search?${getSearchQueryFromFilter({ ...FILTERS, sortBy: 'luxPlusList' })}`

interface Props {
  analyticsPage: string
}

function LuxPlusMonthEarlyAccessOfferCarousel({ analyticsPage }: Props) {
  const tracking = useOfferListTracking(getListName('OfferList', analyticsPage, 'Early access'))
  const canViewLuxPlusBenefits = useAppSelector(getCanViewLuxPlusBenefits)

  return <OfferListEventsProvider tracking={tracking}>
    <OfferCardCarouselSection
      tileSize="medium"
      tileStyle={canViewLuxPlusBenefits ? 'card-default' : 'card-locked'}
      title={<FormattedMessage
        id="l0ArFXu87-J39YX3hL9Q"
        defaultMessage="<i>More early-access</i> offers for LuxPlus+ Month"
        description="Carousel title for LuxPlus+ Month early-access offers"
        values={{ i: (chunks) => <i>{chunks}</i> }}
      />}
      filters={FILTERS}
      allLink={canViewLuxPlusBenefits ? ALL_LINK : undefined}
      minimumOffersCount={3}
      id="early_access"
    />
  </OfferListEventsProvider>
}

export default LuxPlusMonthEarlyAccessOfferCarousel
